import React, { useRef, useEffect } from 'react';
import useTheme from '../../hooks/useTheme';

const SubcategoryList = ({ 
  subcategories = [], 
  selectedSubcategory, 
  onSubcategorySelect,
  onSubcategoryIdSelect 
}) => {
  const theme = useTheme();
  const scrollRef = useRef(null);
  const selectedRef = useRef(null);

  // Auto-scroll to selected subcategory
  useEffect(() => {
    if (selectedRef.current && scrollRef.current) {
      const container = scrollRef.current;
      const selected = selectedRef.current;
      const containerWidth = container.offsetWidth;
      const selectedLeft = selected.offsetLeft;
      const selectedWidth = selected.offsetWidth;
      const scrollLeft = selectedLeft - (containerWidth / 2) + (selectedWidth / 2);
      
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }, [selectedSubcategory]);

  // If no subcategories, don't render
  if (!subcategories || subcategories.length === 0) {
    return null;
  }

  // Always add "All" as first item
  const allSubcategories = [
    { name: 'All', id: 'all' },
    ...subcategories
  ];

  return (
    <div className="w-full py-0.5 md:py-1 overflow-hidden"
    style={{ marginTop: '2px' }}>
      <div className="max-w-screen-xl mx-auto">
        <div 
          ref={scrollRef}
          className="flex items-center justify-start md:justify-center space-x-1.5 md:space-x-2 overflow-x-auto hide-scrollbar px-4 md:px-6"
          style={{
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            paddingTop: '2px',
            paddingBottom: '2px'
          }}
        >
          {allSubcategories.map((subcategory, index) => {
            const isSelected = selectedSubcategory === subcategory.name;
            const hasImage = subcategory.DocImage?.imageUrl;
            
            return (
              <button
                key={subcategory.id || index}
                ref={isSelected ? selectedRef : null}
                onClick={() => {
                  onSubcategorySelect(subcategory.name);
                  // Pass null if it's "All", otherwise pass the actual subcategory id
                  const subcategoryIdToPass = subcategory.id === 'all' ? null : subcategory.id;
                  console.log('Subcategory selected:', subcategory.name, 'ID:', subcategoryIdToPass);
                  onSubcategoryIdSelect && onSubcategoryIdSelect(subcategoryIdToPass);
                }}
                className="flex-shrink-0 px-2 py-1 md:px-3 md:py-1.5 rounded-full transition-all duration-300 border font-medium poppins flex items-center space-x-1"
                style={{
                  backgroundColor: isSelected 
                    ? theme.colors.highlightedBg || theme.colors.secondaryColor
                    : theme.colors.allCategoriesBg || 'transparent',
                  color: isSelected 
                    ? theme.colors.highlightedText || theme.colors.secondaryColor
                    : theme.name === 'palm' ? '#000000' : (theme.colors.allCategoriesText || theme.colors.textPrimary || '#000000'),
                  borderColor: isSelected 
                    ? theme.colors.highlightedText || theme.colors.secondaryColor
                    : theme.colors.allCategoriesBorder || '#d1d5db',
                  transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                  boxShadow: isSelected 
                    ? `0 2px 6px ${theme.colors.highlightedText || theme.colors.secondaryColor}30` 
                    : 'none',
                  fontSize: '11px',
                  fontWeight: isSelected ? '600' : '500',
                }}
              >
                {hasImage && (
                  <img 
                    src={subcategory.DocImage.imageUrl} 
                    alt={subcategory.name}
                    className="w-3.5 h-3.5 md:w-4 md:h-4 object-contain rounded-full"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
                <span>{subcategory.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SubcategoryList;

